<template>
    <div>
        <button
            class="px-5 py-2 gap-2 rounded-md uppercase border text-black text-opacity-70 text-xs font-medium"
        >
            <slot></slot>
        </button>
    </div>
</template>
<script>
export default {
};
</script>
